import PropTypes from 'prop-types';
import Container from '@/components/Container';
import Categories from '@/domain/Blog/Categories';
import PostBreadcrumb from '@/domain/Post/PostBreadcrumb';
import PostTrainer from '@/domain/Post/PostTrainer';
import PostTitle from '@/domain/Post/PostTitle';
import PostDate from '@/domain/Post/PostDate';
import PostFeaturedImage from '@/domain/Post/PostFeaturedImage';
import PostContent from '@/domain/Post/PostContent';
import PostDisclaimer from '@/domain/Post/PostDisclaimer';
import client from '@/api/client';
import { postQuery, postSlugsQuery } from '@/api/queries';

export async function getStaticProps({ params }) {
  const { data } = await client().query({
    query: postQuery,
    variables: {
      id: params.slug[params.slug.length - 1],
    },
  });

  return {
    props: {
      post: data.post,
      categories: data.categories?.nodes || [],
    },
  };
}

export async function getStaticPaths() {
  const { data } = await client().query({ query: postSlugsQuery });

  const paths = data?.posts?.nodes?.map(({ uri }) => {
    const parts = uri.slice(0, -1).split('/').slice(2);
    return {
      params: {
        slug: parts.slice(1),
        category: parts[0],
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
}

const defaultProps = {
  categories: [],
};

const propTypes = {
  post: PropTypes.object.isRequired,
  categories: PropTypes.arrayOf(PropTypes.object),
};

export default function Post({ post, categories }) {
  const trainer = post.info?.trainer;
  const featuredImage = post.featuredImage?.node;
  const hasTrainer = trainer !== null;
  const hasFeaturedImage = featuredImage !== null;
  const hasCategories = post?.categories?.nodes !== null;
  const hasGlobalCategories = categories.length !== 0;

  return (
    <>
      {hasGlobalCategories && <Categories categories={categories} />}
      <div className="bg-gray-100 py-10 lg:py-20">
        <Container>
          <div className="grid grid-cols-1 space-y-10 lg:grid-cols-12 lg:gap-10 lg:space-y-0">
            <div className="lg:col-span-3 lg:pt-4 lg:pb-20">
              <div className="lg:sticky lg:top-32 lg:space-y-20">
                {hasCategories && (
                  <PostBreadcrumb categories={post.categories.nodes} />
                )}
                {hasTrainer && <PostTrainer trainer={trainer} />}
              </div>
            </div>
            <div className="space-y-10 lg:col-span-9 lg:pr-20">
              <div className="space-y-10">
                <PostTitle title={post.title} />
                <PostDate date={post.date} />
                {hasFeaturedImage && (
                  <PostFeaturedImage title={post.title} image={featuredImage} />
                )}
              </div>
              <PostContent content={post.content} />
              <PostDisclaimer />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

Post.defaultProps = defaultProps;
Post.propTypes = propTypes;
